import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequest, performPostRequest } from '@atlassian/jira-fetch';

export type CompletedUserTaskResponse = {
	readonly completedItems: string[];
};

export const addList = async (cloudId: string): Promise<void> => {
	try {
		return await performPostRequest(
			`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/request-tab`,
		);
	} catch (error: unknown) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'addList',
					packageName: 'jiraProjectsDirectoryV3',
					teamName: 'jira-cosmos',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		return Promise.resolve();
	}
};

export const getCompletedItem = async (cloudId: string): Promise<CompletedUserTaskResponse> => {
	try {
		const response = await performGetRequest(
			`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/request-tab`,
		);
		return response;
	} catch (error: unknown) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'getCompletedList',
					packageName: 'jiraProjectsDirectoryV3',
					teamName: 'jira-cosmos',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};

export const markItemCompleted = async (cloudId: string, action: string): Promise<void> => {
	try {
		return await performPostRequest(
			`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/request-tab/item/${action}`,
		);
	} catch (error: unknown) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'markItemCompleted',
					packageName: 'jiraProjectsDirectoryV3',
					teamName: 'jira-cosmos',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		return Promise.resolve();
	}
};
